// actionTypes.js
export const SET_AUTH = 'SET_AUTH';
export const SET_CART = 'SET_CART';
